import { useState, useEffect } from "react";
import { useTheme } from "../components/Theme";

const ORANGE = "#FF6B2B";

const PERFIS_CONFIG = [
  { id: "gerente",      label: "Gerente",      emoji: "👔", color: "#8b5cf6" },
  { id: "vendedor",     label: "Vendedor",      emoji: "👤", color: "#6366f1" },
  { id: "visualizador", label: "Visualizador",  emoji: "👁️", color: "#3b82f6" },
];

const ABAS = [
  { id: "leads",         label: "Leads",         emoji: "👥", categoria: "Navegação" },
  { id: "kanban",        label: "Kanban",         emoji: "📋", categoria: "Navegação" },
  { id: "negociacoes",   label: "Negociações",    emoji: "💰", categoria: "Navegação" },
  { id: "projetos",      label: "Projetos",       emoji: "🗂️", categoria: "Navegação" },
  { id: "financeiro",    label: "Financeiro",     emoji: "💳", categoria: "Navegação" },
  { id: "calendario",    label: "Calendário",     emoji: "📅", categoria: "Navegação" },
  { id: "dashboard",     label: "Dashboard",      emoji: "📊", categoria: "Navegação" },
  { id: "vendas",        label: "Painel Vendas",  emoji: "🏆", categoria: "Navegação" },
  { id: "comissoes",     label: "Comissões",      emoji: "🧮", categoria: "Navegação" },
  { id: "clientes",      label: "Clientes",       emoji: "✅", categoria: "Navegação" },
];

const ACOES = [
  { id: "criar_lead",       label: "Criar leads",           emoji: "➕", categoria: "Ações" },
  { id: "editar_lead",      label: "Editar leads",          emoji: "✏️", categoria: "Ações" },
  { id: "excluir_lead",     label: "Excluir leads",         emoji: "🗑️", categoria: "Ações" },
  { id: "ver_todos_leads",  label: "Ver leads de todos",    emoji: "👁️", categoria: "Ações" },
  { id: "criar_grupo",      label: "Criar grupos",          emoji: "📁", categoria: "Ações" },
  { id: "editar_negoc",     label: "Editar negociações",    emoji: "✏️", categoria: "Ações" },
  { id: "ver_financeiro",   label: "Ver financeiro",        emoji: "💳", categoria: "Ações" },
  { id: "criar_lancamento", label: "Criar lançamentos",     emoji: "💰", categoria: "Ações" },
];

const PERMISSOES_PADRAO = {
  gerente: {
    leads:true, kanban:true, negociacoes:true, projetos:true, financeiro:true,
    calendario:true, dashboard:true, vendas:true, clientes:true,
    criar_lead:true, editar_lead:true, excluir_lead:true, ver_todos_leads:true,
    criar_grupo:true, editar_negoc:true, ver_financeiro:true, criar_lancamento:true,
  },
  vendedor: {
    leads:true, kanban:true, negociacoes:true, projetos:true, financeiro:false,
    calendario:true, dashboard:false, vendas:false, clientes:true,
    criar_lead:true, editar_lead:true, excluir_lead:false, ver_todos_leads:false,
    criar_grupo:false, editar_negoc:true, ver_financeiro:false, criar_lancamento:false,
  },
  visualizador: {
    leads:true, kanban:true, negociacoes:false, projetos:false, financeiro:false,
    calendario:false, dashboard:true, vendas:false, clientes:false,
    criar_lead:false, editar_lead:false, excluir_lead:false, ver_todos_leads:true,
    criar_grupo:false, editar_negoc:false, ver_financeiro:false, criar_lancamento:false,
  },
};

function Toggle({ value, onChange, color="#10b981" }) {
  const { theme } = useTheme();
  return (
    <div onClick={()=>onChange(!value)} style={{ width:44, height:24, borderRadius:12, background:value?color:"#3D3D42", cursor:"pointer", position:"relative", transition:"background .2s", flexShrink:0 }}>
      <div style={{ width:18, height:18, borderRadius:"50%", background:theme.bgCard, position:"absolute", top:3, left:value?23:3, transition:"left .2s", boxShadow:"0 1px 4px rgba(0,0,0,.3)" }}/>
    </div>
  );
}

export default function Permissoes({ currentUser }) {
  const { theme } = useTheme();
  const [perms, setPerms] = useState(() => {
    try { return JSON.parse(localStorage.getItem("crm_permissoes")) || PERMISSOES_PADRAO; }
    catch { return PERMISSOES_PADRAO; }
  });
  const [perfilAtivo, setPerfilAtivo] = useState("vendedor");
  const [salvo, setSalvo] = useState(false);

  const toggle=(perfil,chave)=>{
    setPerms(prev=>({ ...prev, [perfil]:{ ...prev[perfil], [chave]:!prev[perfil]?.[chave] } }));
  };

  const salvar=()=>{
    localStorage.setItem("crm_permissoes", JSON.stringify(perms));
    // Disparar evento para atualizar outros componentes
    window.dispatchEvent(new Event("permissoes_atualizadas"));
    setSalvo(true);
    setTimeout(()=>setSalvo(false), 2500);
  };

  const resetar=(perfil)=>{
    setPerms(prev=>({ ...prev, [perfil]:{ ...PERMISSOES_PADRAO[perfil] } }));
  };

  const categorias = [...new Set([...ABAS,...ACOES].map(i=>i.categoria))];
  const itensPorCat = (cat) => [...ABAS,...ACOES].filter(i=>i.categoria===cat);

  if (currentUser?.role !== "admin") return (
    <div style={{ padding:80, textAlign:"center", background:theme.bg, minHeight:"60vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", fontFamily:"'Inter',sans-serif" }}>
      <div style={{ fontSize:56, marginBottom:20 }}>🔒</div>
      <h3 style={{ margin:"0 0 10px", color:theme.text, fontSize:22, fontWeight:700 }}>Acesso Restrito</h3>
      <p style={{ margin:0, fontSize:15, color:theme.textMuted }}>Só o Administrador pode alterar permissões.</p>
    </div>
  );

  const perfil = PERFIS_CONFIG.find(p=>p.id===perfilAtivo);

  return (
    <div style={{ padding:"24px 28px", fontFamily:"'Inter',-apple-system,sans-serif", background:theme.bg, minHeight:"100vh" }}>

      <div style={{ marginBottom:24 }}>
        <h2 style={{ margin:"0 0 6px", fontSize:22, fontWeight:800, color:theme.text }}>Permissões por Perfil</h2>
        <p style={{ margin:0, fontSize:14, color:theme.textMuted }}>Defina o que cada perfil pode ver e fazer no CRM. O Admin sempre tem acesso total.</p>
      </div>

      {/* Seletor de perfil */}
      <div style={{ display:"flex", gap:10, marginBottom:24, flexWrap:"wrap" }}>
        {PERFIS_CONFIG.map(p=>(
          <button key={p.id} onClick={()=>setPerfilAtivo(p.id)} style={{ display:"flex", alignItems:"center", gap:10, padding:"12px 20px", borderRadius:12, cursor:"pointer", border:`2px solid ${perfilAtivo===p.id?p.color:theme.border}`, background:perfilAtivo===p.id?p.color+"18":theme.bgCard, transition:"all .15s", fontFamily:"'Inter',sans-serif" }}>
            <span style={{ fontSize:22 }}>{p.emoji}</span>
            <div style={{ textAlign:"left" }}>
              <div style={{ fontSize:14, fontWeight:700, color:perfilAtivo===p.id?p.color:theme.text }}>{p.label}</div>
              <div style={{ fontSize:11, color:theme.textMuted }}>{Object.values(perms[p.id]||{}).filter(Boolean).length} permissões ativas</div>
            </div>
            {perfilAtivo===p.id&&<div style={{ width:8, height:8, borderRadius:"50%", background:p.color, marginLeft:4 }}/>}
          </button>
        ))}
      </div>

      {/* Grid de permissões do perfil selecionado */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:24 }}>
        {categorias.map(cat=>(
          <div key={cat} style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:14, overflow:"hidden", boxShadow:theme.name==="light"?"0 1px 4px rgba(0,0,0,.06)":"none" }}>
            <div style={{ padding:"14px 18px", borderBottom:`1px solid ${theme.border}`, background:theme.bgInput, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span style={{ fontSize:13, fontWeight:700, color:theme.text }}>{cat}</span>
              <div style={{ display:"flex", gap:6 }}>
                <button onClick={()=>{ const items=itensPorCat(cat); const novo={...perms[perfilAtivo]}; items.forEach(i=>novo[i.id]=true); setPerms(p=>({...p,[perfilAtivo]:novo})); }}
                  style={{ background:perfil.color+"22", border:`1px solid ${perfil.color}44`, borderRadius:6, padding:"3px 10px", color:perfil.color, fontSize:11, fontWeight:600, cursor:"pointer" }}>
                  Tudo
                </button>
                <button onClick={()=>{ const items=itensPorCat(cat); const novo={...perms[perfilAtivo]}; items.forEach(i=>novo[i.id]=false); setPerms(p=>({...p,[perfilAtivo]:novo})); }}
                  style={{ background:"#ef444418", border:"1px solid #ef444433", borderRadius:6, padding:"3px 10px", color:"#ef4444", fontSize:11, fontWeight:600, cursor:"pointer" }}>
                  Nenhum
                </button>
              </div>
            </div>
            <div style={{ padding:"8px 0" }}>
              {itensPorCat(cat).map(item=>{
                const ativo = perms[perfilAtivo]?.[item.id] || false;
                return (
                  <div key={item.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 18px", borderBottom:`1px solid ${theme.border}22`, cursor:"pointer" }}
                    onClick={()=>toggle(perfilAtivo,item.id)}
                    onMouseEnter={e=>e.currentTarget.style.background=theme.bgInput}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <span style={{ fontSize:16 }}>{item.emoji}</span>
                      <span style={{ fontSize:13, color:ativo?theme.text:theme.textMuted, fontWeight:ativo?500:400 }}>{item.label}</span>
                    </div>
                    <Toggle value={ativo} onChange={v=>toggle(perfilAtivo,item.id)} color={perfil.color}/>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Comparação entre perfis */}
      <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:14, overflow:"hidden", marginBottom:24 }}>
        <div style={{ padding:"14px 20px", borderBottom:`1px solid ${theme.border}`, background:theme.bgInput }}>
          <span style={{ fontSize:13, fontWeight:700, color:theme.text }}>📊 Comparação entre perfis</span>
        </div>
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr>
                <th style={{ padding:"10px 18px", fontSize:11, color:theme.textMuted, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase", textAlign:"left", borderBottom:`1px solid ${theme.border}`, minWidth:200 }}>Permissão</th>
                <th style={{ padding:"10px 0", fontSize:11, color:theme.textMuted, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase", textAlign:"center", borderBottom:`1px solid ${theme.border}`, width:90 }}>⚡ Admin</th>
                {PERFIS_CONFIG.map(p=>(
                  <th key={p.id} style={{ padding:"10px 0", fontSize:11, color:p.color, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase", textAlign:"center", borderBottom:`1px solid ${theme.border}`, width:110 }}>{p.emoji} {p.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...ABAS,...ACOES].map(item=>(
                <tr key={item.id} style={{ borderBottom:`1px solid ${theme.border}22` }}
                  onMouseEnter={e=>e.currentTarget.style.background=theme.bgInput}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <td style={{ padding:"9px 18px", fontSize:13, color:theme.textSub }}>
                    <span style={{ marginRight:8 }}>{item.emoji}</span>{item.label}
                  </td>
                  {/* Admin sempre tem tudo */}
                  <td style={{ textAlign:"center" }}>
                    <span style={{ color:"#10b981", fontSize:16 }}>✓</span>
                  </td>
                  {PERFIS_CONFIG.map(p=>{
                    const ativo = perms[p.id]?.[item.id]||false;
                    return (
                      <td key={p.id} style={{ textAlign:"center" }}>
                        <span onClick={()=>toggle(p.id,item.id)} style={{ color:ativo?"#10b981":"#ef4444", fontSize:16, cursor:"pointer" }}>{ativo?"✓":"✕"}</span>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Botões */}
      <div style={{ display:"flex", gap:12, alignItems:"center" }}>
        <button onClick={salvar} style={{ background:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, border:"none", borderRadius:12, padding:"13px 32px", color:"#fff", fontWeight:700, fontSize:15, cursor:"pointer", boxShadow:`0 4px 14px ${ORANGE}44`, fontFamily:"'Inter',sans-serif" }}>
          💾 Salvar permissões
        </button>
        <button onClick={()=>resetar(perfilAtivo)} style={{ background:theme.bgInput, border:`1px solid ${theme.border}`, borderRadius:12, padding:"13px 20px", color:theme.textMuted, fontWeight:600, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>
          ↺ Resetar {perfil?.label}
        </button>
        {salvo&&<span style={{ color:"#10b981", fontSize:14, fontWeight:600 }}>✅ Permissões salvas!</span>}
      </div>

      <div style={{ marginTop:16, padding:"12px 16px", background:"#f59e0b18", border:"1px solid #f59e0b33", borderRadius:10, fontSize:13, color:"#f59e0b" }}>
        ⚠️ As permissões são aplicadas na próxima vez que o usuário fizer login ou recarregar a página.
      </div>
    </div>
  );
}
